import { render, staticRenderFns } from "./formPageEditWrapper.vue?vue&type=template&id=acfb688e&scoped=true&"
import script from "./formPageEditWrapper.vue?vue&type=script&lang=js&"
export * from "./formPageEditWrapper.vue?vue&type=script&lang=js&"
import style0 from "./formPageEditWrapper.vue?vue&type=style&index=0&id=acfb688e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb688e",
  null
  
)

export default component.exports